import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** stop square. Decorative line icon; always pair with a visible text label. */
export function StopIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <rect x="6.5" y="6.5" width="11" height="11" rx="2" />
    </IconSvg>
  )
}
